import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Colors from '../../styles/colors';

const props = {
  label: PropTypes.string,
  onClick: PropTypes.func,
  styles: PropTypes.object,
};

export const OrangeSubmitButton = props => {
  const { id, label, onClick, styles } = props;
  return (
    <div
      id={id}
      style={{ ..._styles.orangeSubmitButton, ...(styles || {}) }}
      onClick={onClick}
      className="text-center"
      {...props}
    >
      {label}
    </div>
  );
};
OrangeSubmitButton.propTypes = props;

export const TransparentShortSubmitButton = props => {
  const { label, onClick, styles } = props;
  return (
    <div
      style={{
        ..._styles.orangeSubmitButton,
        ..._styles.transparentShortSubmitButton,
        ...(styles || {}),
      }}
      onClick={onClick}
      className="text-center"
      {...props}
    >
      {label}
    </div>
  );
};
TransparentShortSubmitButton.propTypes = props;

export const ActionButton = styled.button`
  width: 150px;
  line-height: 30px;
  background-color: ${props => props.backgroundColor || '#f76b1c'};
  border-radius: 5px;
  overflow: hidden;
  margin: 3px;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 1px;
  color: ${props => props.textColor || '#fff'};
  padding: 6px 20px;
  border: 1px solid ${props => props.borderColor || '#f76b1c'};
  cursor: ${props => props.cursor || 'pointer'};
  display: inline-block;
`;

export const ButtonConfirm = styled.div`
  text-align: center;

  .cbtn {
    background-color: ${Colors.mainOrange};
    width: 150px;
    padding: 10px;
    border: 1px solid ${Colors.mainOrange};
    color: ${Colors.mainWhite};
    font-size: 1.6rem;
    border-radius: 5px;
    margin: 20px 5px;
    font-weight: 500;

    &.cancel {
      background-color: ${Colors.mainWhite};
      color: ${Colors.mainOrange};
      border-width: 2px;
    }
  }
`;

const _styles = {
  orangeSubmitButton: {
    width: 229,
    lineHeight: '30px',
    backgroundColor: Colors.mainOrange,
    borderRadius: 5,
    overflow: 'hidden',
    margin: '40px auto',
    fontSize: 14,
    fontWeight: 'bold',
    letterSpacing: 1,
    wordSpacing: 3,
    color: Colors.mainWhite,
    padding: '6px 20px',
    border: `1px solid ${Colors.mainOrange}`,
    cursor: 'pointer',
  },
  transparentShortSubmitButton: {
    backgroundColor: 'transparent',
    width: 97,
    color: Colors.darkGrey,
    borderColor: Colors.darkGrey,
  },
};
